<template>
  <div>
    <nav-top/>
    <div class="container-fluid">
      <div class="row flex-xl-nowrap">
        <div :class="{'bd-banner-sidebar': isBannerEnabled}" class="col-12 col-md-3 col-xl-2 bd-sidebar">
          <nav-left/>
          <pre class="small d-none d-md-block text-muted"> v{{version}} </pre>
        </div>
        <main class="col-12 col-md-9 col-xl-10 py-3 px-md-5 bd-content" role="main">
          <slot/>
          <div class="d-md-none">
            <hr/>
            <pre class="small text-muted"> v{{version}} </pre>
          </div>
        </main>
      </div>
    </div>
  </div>
</template>

<script>
import NavTop from '@/components/navigation/nav-top'
import NavLeft from '@/components/navigation/nav-left'
export default {
  name: 'layout-sidebar',
  components: {
    NavTop,
    NavLeft
  },
  data() {
    return {
      version: process.env.version
    }
  },
  computed: {
    isBannerEnabled() {
      let env = window.config ? window.config.environment : ''
      return env !== 'prod'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/layouts/side-nav.vue